import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import {
  Alert,
  CircularProgress,
  Container,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { connect } from 'react-redux';
import {
  addPartner,
  deletePartner,
  getSinglePartner,
  getAllPartners,
  updatePartner,
} from 'src/redux/actions/partner';
import {
  ADD_PARTNER,
  DELETE_PARTNER,
  GET_SINGLE_PARTNER,
  GET_ALL_PARTNERS,
  UPDATE_PARTNER,
} from 'src/redux/actionTypes';
import DataWidget from 'src/components/widgets/DataWidget';
import CreatePartnerSidebar from 'src/sections/partner/PartnerSidebar';
import PartnerCard from 'src/sections/partner/PartnerCard';

const PartnerPage = ({
  partners,
  error,
  getAvailablePartners,
  paginationDetails,
  deletePartner,
  addPartner,
  message,
  updatePartner,
  loading,
}) => {
  useEffect(() => {
    if (partners.length === 0) {
      getAvailablePartners({});
    }
  }, []);

  const [openSidebar, setOpenSidebar] = useState({
    show: false,
    data: null,
  });

  const handleOpenSidebar = data => {
    setOpenSidebar({ show: true, data });
  };

  const handleCloseSidebar = () => {
    setOpenSidebar({ show: false, data: null });
  };

  const [deleting, setDeleting] = useState();
  const [deleteError, setDeleteError] = useState();
  const [deleteSuccess, setDeleteSuccess] = useState();

  useEffect(() => {
    if (error?.action === DELETE_PARTNER) {
      setDeleteError(error.message);
    }
    if (message?.action === DELETE_PARTNER) {
      setDeleteSuccess(message.success);
    }
    if (
      (message?.action === UPDATE_PARTNER ||
        message?.action === ADD_PARTNER)
    ) {
      setDeleteSuccess(
        message.success,
      );
      handleCloseSidebar();
    }
    setDeleting();
  }, [message, error]);

  return (
    <>
      <Helmet>
        <title> Dashboard: Partners | TGHrC </title>
      </Helmet>

      <Container>
        {deleteError && (
          <Alert variant="standard" severity="error" sx={{ mt: 2 }}>
            {deleteError}
          </Alert>
        )}
        {deleteSuccess && (
          <Alert variant="standard" severity="success" sx={{ mt: 2 }}>
            {deleteSuccess}
          </Alert>
        )}
        {deleting && (
          <Alert
            variant="standard"
            severity="info"
            icon={<CircularProgress size={20} />}
            sx={{ mt: 2 }}
          >
            Deleting <strong>"{deleting.name}"</strong> partner ...
          </Alert>
        )}
        <Stack
          direction="row"
          spacing={1}
          flexShrink={0}
          sx={{ my: 1, mb: 5 }}
          justifyContent="space-between"
        >
          <Typography variant="h4">Partners</Typography>
          <CreatePartnerSidebar
            openSidebar={openSidebar.show}
            onOpenSidebar={() => handleOpenSidebar(null)}
            data={openSidebar.data}
            onCloseSidebar={() => handleCloseSidebar()}
            errorApi={error}
            message={message}
            onEditSubmitted={edited => {
              updatePartner(openSidebar.data._id, edited);
            }}
            onSubmit={data => {
              addPartner(data);
            }}
          />
        </Stack>
        <DataWidget
          title={'Partners'}
          isLoading={loading && !partners.length && !error}
          isError={
            !loading && error && !partners.length ? error : null
          }
          isEmpty={!error && !loading && !partners.length}
        >
          <Grid container spacing={3}>
            {partners.map(partner => (
              <Grid key={partner._id} item xs={12} sm={6} md={4}>
                <PartnerCard
                  partner={partner}
                  onEdit={() => {
                    handleOpenSidebar(partner);
                  }}
                  isDeleting={
                    deleting?.id === partner._id ||
                    openSidebar.data?._id === partner._id
                  }
                  onDelete={() => {
                    setDeleting({
                      id: partner._id,
                      name: partner.name,
                    });
                    setDeleteSuccess();
                    setDeleteError();
                    return deletePartner(partner._id);
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </DataWidget>
      </Container>
    </>
  );
};

const mapStateToProps = state => ({
  partners: state.partner.partners,
  message: state.partner.message,
  paginationDetails: state.partner.paginationDetails,
  error: state.partner.error,
  loading: state.partner.loading,
});

const mapDispatchToProps = dispatch => {
  return {
    getAvailablePartners: queries =>
      dispatch(getAllPartners(queries)),
    addPartner: data => dispatch(addPartner(data)),
    deletePartner: id => dispatch(deletePartner(id)),
    updatePartner: (id, data) => dispatch(updatePartner(id, data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PartnerPage);
